module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-texasMonthly.3e6a266d1f86c6168b17c3f0ff5cc9e6.png";